function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-521.000000, -625.000000)",
  fill: "#222933"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(521.000000, 625.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.77777778,16.2 L14.2222222,16.2 L14.2222222,6.3 L1.77777778,6.3 L1.77777778,16.2 Z M14.2222222,1.8 L13.3333333,1.8 L13.3333333,0 L11.5555556,0 L11.5555556,1.8 L4.44444444,1.8 L4.44444444,0 L2.66666667,0 L2.66666667,1.8 L1.77777778,1.8 C0.791111111,1.8 0.00888888889,2.61 0.00888888889,3.6 L0,16.2 C0,17.19 0.791111111,18 1.77777778,18 L14.2222222,18 C15.2,18 16,17.19 16,16.2 L16,3.6 C16,2.61 15.2,1.8 14.2222222,1.8 L14.2222222,1.8 Z M10.6666667,9.9 L12.4444444,9.9 L12.4444444,8.1 L10.6666667,8.1 L10.6666667,9.9 Z M7.11111111,9.9 L8.88888889,9.9 L8.88888889,8.1 L7.11111111,8.1 L7.11111111,9.9 Z M3.55555556,9.9 L5.33333333,9.9 L5.33333333,8.1 L3.55555556,8.1 L3.55555556,9.9 Z"
}))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.36bb8310.svg";
export { ForwardRef as ReactComponent };